import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import httpRequest from '@/axios'
import { Form, Field, CellGroup, List, Cell, NoticeBar, Col, Row,Button,Tag,Icon,Overlay,Loading } from 'vant';
import 'vant/lib/index.css';



const app = createApp(App)
// 挂载全局
app.use(router);
app.config.globalProperties.$http = httpRequest
app.use(Form);
app.use(Field);
app.use(Cell);
app.use(CellGroup);
app.use(List);
app.use(Col);
app.use(Row);
app.use(Button);
app.use(NoticeBar);
app.use(Tag);
app.use(Icon);
app.use(Overlay);
app.use(Loading);
app.mount('#app');



